import api from '../utils/api';
import { normalizeApiResponse } from '../utils/apiResponseHandler';

// Pricing Plan service for API calls
export const pricingPlanService = {
  // Get all pricing plans with optional filters
  getPricingPlans: async (params = {}) => {
    try {
      const {
        is_active = ''  // Status filter parameter
      } = params;
      
      const queryParams = new URLSearchParams();
      if (is_active !== '') {
        queryParams.append('is_active', is_active);
      }
      
      const url = queryParams.toString() 
        ? `/admin/pricing-plans?${queryParams.toString()}` 
        : '/admin/pricing-plans';
      
      const response = await api.get(url);
      return normalizeApiResponse(response, 'plans');
    } catch (error) {
      throw error;
    }
  },

  // Get single pricing plan by ID
  getPricingPlan: async (planId) => {
    try {
      const response = await api.get(`/admin/pricing-plans/${planId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Create new pricing plan
  createPricingPlan: async (planData) => {
    try {
      const response = await api.post('/admin/pricing-plans', planData);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Update pricing plan
  updatePricingPlan: async (planId, planData) => {
    try {
      const response = await api.put(`/admin/pricing-plans/${planId}`, planData);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Delete pricing plan
  deletePricingPlan: async (planId) => {
    try {
      const response = await api.delete(`/admin/pricing-plans/${planId}`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Toggle pricing plan status
  togglePlanStatus: async (planId) => {
    try {
      const response = await api.post(`/admin/pricing-plans/${planId}/toggle-status`);
      return normalizeApiResponse(response);
    } catch (error) {
      throw error;
    }
  },

  // Get available pricing plans (for users)
  getAvailablePricingPlans: async () => {
    try {
      const response = await api.get('/available-pricing-plans');
      return normalizeApiResponse(response, 'plans');
    } catch (error) {
      throw error;
    }
  }
};

export default pricingPlanService;